// Controls that handle their own click — row navigation skips these.
const INTERACTIVE_SELECTOR = "a, button, input, .ant-checkbox-wrapper, .ant-switch, .ant-select";

// Whole-row click → navigate to `to`, covering the gaps the cell's <a> doesn't reach.
export const handleRowNavigation = (event, to, history) => {
  if (!to) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey) return;
  if (event.target.closest(INTERACTIVE_SELECTOR)) return;
  const selection = typeof window !== "undefined" && window.getSelection ? window.getSelection() : null;
  if (selection && selection.toString().length > 0) return;
  history.push(to);
};
